import React from "react";
import { Route, Routes } from "react-router-dom";

import { useSelector } from "react-redux";

import Signin from "./Signin";
import ProspectsLayout from "./Layouts/ProspectsLayout";
import NotFound from "./404";

// User
import AccountSettings from "./User/AccountSettings";

const Pages = () => {
  const state = useSelector((state) => state.user);
  const { isSignedIn } = state;

  return (
    <>
      <Routes>
        <Route
          path="/"
          element={isSignedIn ? <ProspectsLayout /> : <Signin />}
          exact
        />
        <Route
          path="/signin"
          element={isSignedIn ? <NotFound /> : <Signin />}
          exact
        />
        <Route
          path="/prospects"
          element={isSignedIn ? <ProspectsLayout /> : <NotFound />}
          exact
        />
        <Route
          path="/settings"
          element={isSignedIn ? <AccountSettings /> : <NotFound />}
          exact
        />
        <Route path="/not-found" element={<NotFound />} exact />
      </Routes>
    </>
  );
};

export default React.memo(Pages);
